import type { ReactNode } from 'react';
import styled from 'styled-components';

import { media } from '../../../../helpers/breakpoints';

interface IPanelHeading {
  children: ReactNode;
  hasMarginBottom?: boolean;
}

type THeading = { hasMarginBottom: boolean };
export const Heading = styled.h2<THeading>`
  ${({ theme }) => theme.fontSize.L18};
  margin-bottom: ${({ theme, hasMarginBottom }) =>
    hasMarginBottom ? theme.spacing.M16 : '0'};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  color: ${({ theme }) => theme.colors.GREY_DARKER};

  ${media.large} {
    margin-bottom: ${({ theme, hasMarginBottom }) =>
      hasMarginBottom ? theme.spacing.M24 : '0'};
  }
`;

function PanelHeading({ children, hasMarginBottom = true }: IPanelHeading) {
  return <Heading hasMarginBottom={hasMarginBottom}>{children}</Heading>;
}

export { PanelHeading };
